import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ValidationModule } from 'app/core/services/validation/validation.module';
import { DynamicControlModule } from 'app/modules/dossier-area/components/dynamic-control/dynamic-control.module';
import { DynamicSachverhalteFormComponent } from 'app/modules/dossier-area/components/dynamic-sachverhalte-form/dynamic-sachverhalte-form.component';
import { GenericInlineItemListModule } from 'app/shared/components/generic-inline-item-list/generic-inline-item-list.module';
import { GenericItemListModule } from 'app/shared/components/generic-item-list/generic-item-list.module';
import { MarkdownDirectiveModule } from 'app/shared/directives/markdown/markdown.directive.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ValidationModule,
    DynamicControlModule,
    MarkdownDirectiveModule,
    GenericInlineItemListModule,
    GenericItemListModule,
  ],
  declarations: [DynamicSachverhalteFormComponent],
  exports: [DynamicSachverhalteFormComponent],
})
export class DynamicSachverhalteFormModule { }
